import config from '../../constants';
import { roles } from '../../constants/roles';
import { AdminContextTypeApi } from '../../modules/session';
import get from 'lodash.get';

export const tabs = {
  ALL_USERS: 'all',
  ADMINS: 'admins',
  FUNDRAISERS: 'fundraisers',
  DONORS: 'donors',
  RETENTION: 'retention',
  DONATIONS: 'donations',
  FUNDRAISING: 'fundraising',
  SALES: 'sales',
  DONATION_SUBSCRIPTIONS: 'donationSubscriptions',
  ADMIN: 'admin',
  PLACEHUB_APPLICATIONS: 'placehubApplications',
  CONSENT: 'consent'
};

export const adminColumns = {
  EMAIL: 'email',
  ACCOUNT_LAST_NAME: 'account.lastName',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PERMISSION: 'permission',
  ORGANIZATION_NAME: 'organizationName',
  ORGANIZATION: 'organization.name',
  ROLES: 'roles',
  STATUS: 'status',
  LAST_LOGIN: 'lastLoggedInAt',
  CREATED_AT: 'createdAt',
  CREATED_AT_LOCAL: 'createdAtLocal',
  IS_DONOR: 'isDonor',
  IS_FUNDRAISER: 'isFundraiser',
  IS_ADMIN: 'isAdmin',
  IS_ORG_ADMIN: 'isOrgAdmin',
  ACCOUNT_ID: 'accountId',
  PAGES_COUNT: 'pagesCount',
  AMOUNT_FUNDRAISED: 'raisedAmount',
  ORGANIZATION_ID: 'organizationId',
  ADMIN_ID: 'id',
  AVERAGE_DONATION_AMOUNT: 'averageDonationAmount',
  NUMBER_OF_DONATIONS: 'donationCount',
  CURRENCY: 'currency',
  ADMIN_ACCESS: 'adminAccess'
};

export const donationsColumns = {
  DATE: 'donatedAt',
  AMOUNT: 'amount'
};

// Owned by the data retention module so the surface can move out of accounts later.
export { retentionColumns } from '../dataRetention/constants';

export const fundraisingColumns = {
  NAME: 'name',
  CAMPAIGN: 'campaignName',
  RAISED_AMOUNT: 'raisedAmount',
  AVERAGE_DONATION: 'averageDonationAmount',
  TOTAL_DONATIONS: 'donationCount'
};

export const settingsMenuItems = {
  ACCOUNT_DETAILS: 'account_detail',
  UPDATE_PASSWORD: 'update_passowrd',
  ACCOUNT_SECURITY: 'account_security',
  CAMPAIGN_ADMIN_LIST: 'campaign_admin_list',
  EYES_ONLY: 'eyes_only',
  EMAIL_NOTIFICATIONS: 'email_notifications'
};

export const securitySettingTabs = {
  START: 'start',
  QR_CODE: 'qr_code',
  VERIFICATION: 'verification_code',
  BACK_UP_CODES: 'back_up_codes',
  FINISH: 'finish'
};

export const securityAuthLinks = {
  APP_STORE: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
  PLAY_STORE:
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
};

export const i18nKeys = {
  ACCOUNT_TITLE: 'account.title',
  EDIT_ACTION: 'account.edit-action',
  VIEW_ACTION: 'account.view-action',
  IMPERSONATE_ACTION: 'account.impersonate-action',
  ACTION_HEADER: 'account.list.header.action',
  ALL_USERS_TAB_TITLE: 'account.tabs.all-users-title',
  ADMINS_TAB_TITLE: 'account.tabs.admins-title',
  FUNDRAISERS_TAB_TITLE: 'account.tabs.fundraisers-title',
  DONORS_TAB_TITLE: 'account.tabs.donors-title',
  DONATIONS_TAB_TITLE: 'account.tabs.donations-title',
  FUNDRAISING_TAB_TITLE: 'account.tabs.fundraising-title',
  SALES_TAB_TITLE: 'account.tabs.sales-title',
  DONATION_SUBSCRIPTIONS_TAB_TITLE: 'account.tabs.donation-subscriptions-title',
  ADMIN_TAB_TITLE: 'account.tabs.admin-title',
  PLACEHUB_APPLICATIONS_TAB_TITLE: 'account.tabs.placehub-applications-title',
  CONSENT_TAB_TITLE: 'account.tabs.consent-title',
  RETENTION_TAB_TITLE: 'account.tabs.retention-title',
  RETENTION_VIEW_RULES_ACTION: 'account.retention-view-rules-action',
  RETENTION_DEIDENTIFY_ACTION: 'account.retention-deidentify-action',
  RETENTION_REVERT_ACTION: 'account.retention-revert-action',
  RETENTION_AUDIT_ACTION: 'account.retention-audit-action',
  RETENTION_DEIDENTIFY_BUTTON: 'account.retention-deidentify-button',
  ACCOUNT_SETTINGS_TITLE: 'account.settings.title',
  ACCOUNT_DETAILS_ITEM: 'account.settings.accountDetails',
  ACCOUNT_SECURITY_ITEM: 'account.settings.security',
  EMAIL_NOTIFICATIONS_ITEM: 'account.settings.emailNotifications',
  UPDATE_PASSWORD_ITEM: 'account.settings.updatePassword',
  EYES_ONLY_ITEM: 'account.settings.eyes-only',
  CAMPAIGN_ADMIN_LIST: 'account.settings.campaignAdminList',
  CAMPAIGN_ADMIN_ORGANIZER_LIST: 'account.settings.campaignAdminOrganizerList',
  INVITE_ADMIN_BUTTON: 'account.settings.inviteAdminButton',
  FIRST_NAME: 'account.settings.firstName',
  LAST_NAME: 'account.settings.lastName',
  EMAIL: 'account.settings.email',
  PASSWORD: 'account.settings.password',
  SAVE: 'account.settings.save',
  CANCEL: 'account.settings.cancel',
  PROMOTE: 'account.settings.promote',
  DEMOTE: 'account.settings.demote',
  SELECT_IMAGE_TEXT: 'account.settings.selectImageText',
  IMAGE_FORMAT_TEXT: 'account.settings.imageFormatText',
  ALLOWED_PIXELS_TEXT: 'account.settings.allowedPixelsText',
  PROMOTE_ADMIN_ORGANIZATION_TITLE: 'account.eyes-only.organization.label',
  PROMOTE_ADMIN_ORGANIZATION_PLACEHOLDER:
    'account.eyes-only.organization.placeholder',
  LINKED_CAMPAIGN_ADD_BUTTON: 'account.eyes-only.linkedCampaign.add-button',
  LINKED_CAMPAIGN_ORGANIZER_ADD_BUTTON: 'account.eyes-only.linkedCampaignOrganizer.add-button',
  LINKED_EVENT_ADD_BUTTON: 'account.eyes-only.linkedEvent.add-button',
  LINKED_EVENT_ORGANIZER_ADD_BUTTON:
    'account.eyes-only.linkedEventOrganizer.add-button',
  PROMOTE_ADMIN_LINKED_CAMPAIGN_TITLE: 'account.eyes-only.linkedCampaign.label',
  PROMOTE_ADMIN_LINKED_CAMPAIGN_PLACEHOLDER:
    'account.eyes-only.linkedCampaign.placeholder',
  PROMOTE_ADMIN_LINKED_CAMPAIGN_ORGANIZER_TITLE: 'account.eyes-only.linkedCampaignOrganizer.label',
  PROMOTE_ADMIN_LINKED_CAMPAIGN_ORGANIZER_PLACEHOLDER:
    'account.eyes-only.linkedCampaignOrganizer.placeholder',
  PROMOTE_ADMIN_LINKED_EVENT_TITLE: 'account.eyes-only.linkedEvent.label',
  PROMOTE_ADMIN_LINKED_EVENT_PLACEHOLDER:
    'account.eyes-only.linkedEvent.placeholder',
  PROMOTE_ADMIN_LINKED_EVENT_ORGANIZER_TITLE:
    'account.eyes-only.linkedEventOrganizer.label',
  PROMOTE_ADMIN_LINKED_EVENT_ORGANIZER_PLACEHOLDER:
    'account.eyes-only.linkedEventOrganizer.placeholder',
  PROMOTE_AND_DEMOTE_HEADER: 'account.eyes-only.promoteAndDemote.header',
  PROMOTE_ROLE_LABEL: 'account.eyes-only.promoteAndDemote.promoteRole.label',
  
  // Admin memberships
  ADMIN_MEMBERSHIPS_HEADER: 'account.eyes-only.adminMemberships.header',
  ADMIN_MEMBERSHIPS_EMPTY: 'account.eyes-only.adminMemberships.empty',
  DEMOTE_ALL_BUTTON: 'account.eyes-only.demote.all-button',
  DEMOTE_SINGLE_BUTTON: 'account.eyes-only.demote.single-button',
  DEMOTE_CONFIRM_TITLE: 'account.eyes-only.demote.confirm-title',
  DEMOTE_CONFIRM_MESSAGE: 'account.eyes-only.demote.confirm-message',
  DEMOTE_ALL_CONFIRM_MESSAGE: 'account.eyes-only.demote.all-confirm-message',

  // MFA reset
  MFA_RESET_HEADER: 'account.eyes-only.mfa.header',
  MFA_RESET_ACTIVE: 'account.eyes-only.mfa.active',
  MFA_RESET_INACTIVE: 'account.eyes-only.mfa.inactive',
  MFA_RESET_BUTTON: 'account.eyes-only.mfa.reset-button',
  MFA_RESET_CONFIRM_TITLE: 'account.eyes-only.mfa.confirm-title',
  MFA_RESET_CONFIRM_MESSAGE: 'account.eyes-only.mfa.confirm-message',
  MFA_RESET_SUCCESS_MESSAGE: 'account.eyes-only.mfa.success-message',

  PROMOTE_ADMIN_ROLE_LABEL: 'account.eyes-only.adminRole.label',
  CREATED_AT_LABEL: 'account.eyes-only.createdAt.label',
  
  // Context types
  CONTEXT_TYPE_LABEL: 'account.eyes-only.contextType.label',
  CONTEXT_TYPE_ORGANIZATION: 'account.eyes-only.contextType.organization',
  CONTEXT_TYPE_CAMPAIGN: 'account.eyes-only.contextType.campaign',
  CONTEXT_TYPE_EVENT: 'account.eyes-only.contextType.event',
  CONTEXT_TYPE_CAMPAIGN_ORGANIZER: 'account.eyes-only.contextType.campaignOrganizer',
  CONTEXT_TYPE_EVENT_ORGANIZER: 'account.eyes-only.contextType.eventOrganizer',
  CONTEXT_TYPE_SYSTEM: 'account.eyes-only.contextType.system',
  
  // Admin roles
  ADMIN_ROLE_OWNER: 'account.eyes-only.role.owner',
  ADMIN_ROLE_ADMIN: 'account.eyes-only.role.admin',
  ADMIN_ROLE_VIEWER: 'account.eyes-only.role.viewer',

  // Restricted
  RESTRICTED_LABEL: 'account.eyes-only.restricted.label',
  RESTRICTED_YES: 'account.eyes-only.restricted.yes',

  WEBHOOKS_TITLE: 'webhooks.page.view.title',
  WEBHOOKS_CREATE: 'webhooks.page.setup.title',
  WEBHOOKS_EDIT: 'webhooks.page.edit.title',
  WEBHOOKS_VIEW_ACTION: 'webhooks.page.view.view-action',
  WEBHOOKS_EDIT_ACTION: 'webhooks.page.view.edit-action',
  WEBHOOKS_DELETE_ACTION: 'webhooks.page.view.delete-action',
  TERMINAL_TITLE: 'terminal.title',
  TERMINAL_UNASSIGN_ACTION: 'terminal.unassign-action',
  TERMINAL_ASSIGN_TO_ACTION: 'terminal.assign-to-action',
  TERMINAL_EDIT_ACTION: 'terminal.edit-action',
  TERMINAL_DELETE_ACTION: 'terminal.delete-action',

  // Account detail header
  LAST_LOGGED_IN_AT: 'account.account-detail.lastLoggedInAt',
  NEVER_LOGGED_IN: 'account.account-detail.neverLoggedIn',
  LOGIN_LOCKED_UNTIL: 'account.account-detail.loginLockedUntil',
  LOCKED_FOR: 'account.account-detail.lockedFor',
  ACTIVE_MEMBERSHIPS: 'account.account-detail.activeMemberships',
  REVOKED_MEMBERSHIPS: 'account.account-detail.revokedMemberships',
  NO_MEMBERSHIPS: 'account.account-detail.noMemberships',
  HAS_MFA_ACTIVE: 'account.account-detail.hasMfaActive',
  PASSWORD_VERSION: 'account.account-detail.passwordVersion',
  PASSWORD_VERSION_NOT_SET: 'account.account-detail.passwordVersionNotSet',
  PASSWORD_RESET_REQUIRED_AT: 'account.account-detail.passwordResetRequiredAt',
  PASSWORD_RESET_REQUIRED_SINCE:
    'account.account-detail.passwordResetRequiredSince',
  PASSWORD_RESET_NOT_REQUIRED: 'account.account-detail.passwordResetNotRequired',
  LAST_PASSWORD_CHANGED_AT: 'account.account-detail.lastPasswordChangedAt',
  PASSWORD_NEVER_CHANGED: 'account.account-detail.passwordNeverChanged',
  REPORTED_AS_SPAM_AT: 'account.account-detail.reportedAsSpamAt'
};

export const paths = {
  FIRST_NAME: 'record.data.data.firstName',
  ACTIVE_ITEM: 'activeItem',
  PASSWORD: 'password',
  LAST_NAME: 'record.data.data.lastName',
  EMAIL: 'record.data.data.email',
  TOTOAL_AMOUNT_DONATED_VALUE: 'totalAmountDonated.value',
  TOTOAL_AMOUNT_FUNDRAISED_VALUE: 'totalAmountFundraised.value',
  TOTOAL_AMOUNT_DONATED_ERROR: 'totalAmountDonated.error',
  TOTOAL_AMOUNT_FUNDRAISED_ERROR: 'totalAmountFundraised.error',
  PHOTO_PATH: 'record.data.data.photoPath',
  UPDATE_RECORD_STATE: 'updateRecordState',
  UPLOAD_IMAGE_STATE: 'uploadImageState',
  INVITE_ADMIN_FIRST_NAME: 'firstName',
  INVITE_ADMIN_LAST_NAME: 'lastName',
  INVITE_ADMIN_EMAIL: 'email',
  INVITE_ADMIN_ROLE: 'roles',
  INVITE_ADMIN_ROLE_NAME: 'roleName',
  INVITE_ADMIN_CONTEXT_TYPE: 'contextType',
  INVITE_ADMIN_ORGANIZATION: 'organizationId',
  INVITE_ADMIN_CAMPAIGN: 'roleDetail.campaignId',
  INVITE_ADMIN_EVENT: 'roleDetail.eventId',
  INVITE_ADMIN_EVENT_ORGANIZER: 'roleDetail.eventOrganizerId',
  INVITE_ADMIN_CAMPAIGN_ORGANIZER: 'roleDetail.campaignOrganizerId',
  INVITE_ADMIN_RESTRICT_EXPORTS: 'roleDetail.restrictExports',
  PROMOTE_ADMIN_ORGANIZATION: 'organization',
  PROMOTE_ADMIN_ORGANIZATION_ID: 'organizationId',
  PROMOTE_ADMIN_CAMPAIGN: 'campaign',
  PROMOTE_ADMIN_CAMPAIGN_ORGANIZER: 'campaignOrganizer',
  PROMOTE_ADMIN_EVENT: 'event',
  PROMOTE_ADMIN_CAMPAIGN_ID: 'campaignId',
  PROMOTE_ADMIN_CAMPAIGN_ORGANIZER_ID: 'campaignOrganizerId',
  PROMOTE_ADMIN_EVENT_ID: 'eventId',
  PROMOTE_ADMIN_EVENT_ORGANIZER: 'eventOrganizer',
  PROMOTE_ADMIN_EVENT_ORGANIZER_ID: 'eventOrganizerId',
  IS_ORG_ADMIN: 'record.data.data.isOrgAdmin',
  IS_CAMPAIGN_ADMIN: 'record.data.data.isCampaignAdmin',
  IS_EVENT_ADMIN: 'record.data.data.isEventAdmin',
  IS_EVENT_ORGANIZER_ADMIN: 'record.data.data.isEventOrganizerAdmin',
  IS_CAMPAIGN_ORGANIZER_ADMIN: 'record.data.data.isCampaignAdmin',
  PROMOTE_ADMIN_ROLE: 'promoteRole',
  PROMOTE_ADMIN_ROLE_NAME: 'promoteRoleName',
  PROMOTE_ADMIN_ROLE_LEVEL: 'promoteRoleLevel',
  PROMOTE_CONTEXT_TYPE: 'promoteContextType',
  ORG_ADMIN_DONATION_SUBSCRIPTION_RECEIVED: 'orgAdminDonationSubscriptionReceived',
  ORG_ADMIN_DAILY_SUMMARY_NOTIFICATION: 'orgAdminDailySummaryNotification',
  ORG_ADMIN_DONATION_RECEIVED: 'orgAdminDonationReceived',
  ORG_ADMIN_SALE_CREATED: 'orgAdminSaleCreated',
  ORG_ADMIN_PAGE_CREATED: 'orgAdminPageCreated',
  EMAIL_NOTIFICATIONS: 'emailNotifications'
};

export const fieldNames = {
  RAISED_AMOUNT: 'RaisedAmount',
  AMOUNT: 'Amount'
};

export const upload = {
  AVATAR_TYPE: 'avatar',
  ACCOUNT_ENTITY: 'account'
};

/**
 * The entity id an invite carries, as the list shape the API expects. Autocomplete signals a
 * cleared field by calling onChange({}, {}), so the value arrives undefined, and wrapping that
 * blindly gives [undefined]: a length-one array that isRequiredValid reads as filled, letting an
 * invite be sent with no id in it.
 */
export const toEntityIds = (
  value?: number | string | null
): (number | string)[] => (value == null ? [] : [value]);

/**
 * The validation models for the invite panel, derived wholly from one params object. Taking params
 * rather than props is the point: the role that decides which fields are required and the values
 * being checked have to come from the same snapshot, and reading them from different ones made the
 * panel judge new values against the previously selected role.
 */
export const getInviteValidationModels = (params: any) => {
  const validation: any = getInviteAdminValidation(params?.roles);
  return Object.keys(validation).map((key) => ({
    validationModel: validation[key],
    value: get(params, validation[key].path)
  }));
};

// Not just a number: the initial state carries '' and the System option carries no mask at all,
// and both are compared by identity against the numeric roles below.
export const getInviteAdminValidation = (role?: number | string) => {
  return {
    ORGANIZATION: {
      required: role === roles.ORGANIZATION_ADMIN,
      path: paths.INVITE_ADMIN_ORGANIZATION
    },
    CAMPAIGN: {
      required: role === roles.CAMPAIGN_ADMIN,
      path: paths.INVITE_ADMIN_CAMPAIGN
    },
    EVENT: {
      required: role === roles.EVENT_ADMIN,
      path: paths.INVITE_ADMIN_EVENT
    },
    EVENT_ORGANIZER: {
      required: role === roles.EVENT_ORGANIZER_ADMIN,
      path: paths.INVITE_ADMIN_EVENT_ORGANIZER
    },
    CAMPAIGN_ORGANIZER: {
      required: role === roles.CAMPAIGN_ORGANIZER_ADMIN,
      path: paths.INVITE_ADMIN_CAMPAIGN_ORGANIZER
    },
    EMAIL: {
      required: true,
      email: true,
      maxLength: true,
      length: config.ACCOUNT_EMAIL_MAX_LENGTH,
      path: paths.INVITE_ADMIN_EMAIL
    },
    ROLE: {
      required: true,
      // Validated on the chosen option rather than on the legacy roles mask. Every option sets
      // roleName, but the System one carries a context type instead of a mask, so requiring
      // `roles` would leave the invite button permanently disabled for it.
      path: paths.INVITE_ADMIN_ROLE_NAME
    },
    FIRST_NAME: {
      required: true,
      maxLength: true,
      length: config.ACCOUNT_NAME_MAX_LENGTH,
      path: paths.INVITE_ADMIN_FIRST_NAME
    },
    LAST_NAME: {
      required: true,
      maxLength: true,
      length: config.ACCOUNT_NAME_MAX_LENGTH,
      path: paths.INVITE_ADMIN_LAST_NAME
    }
  };
};

// Status filter values: the enum names the account metadata offers, not the camelCase field values.
export const accountStatusFilter = {
  active: 'Active',
  deleted: 'Deleted'
} as const;

export const allUsersAvailableFilters = [
  'status',
  'adminContextType',
  'adminRole',
  'isSysAdmin',
  'isOrgAdmin',
  'adminFilterOrganizationId',
  'isCampaignAdmin',
  'adminFilterCampaignId',
  'isCampaignOrganizerAdmin',
  'adminFilterCampaignOrganizerId',
  'isEventAdmin',
  'adminFilterEventId',
  'isEventOrganizerAdmin',
  'adminFilterEventOrganizerId',
  'hasMfaActive'
];
export const adminsAvailableFilters = [
  'status',
  'adminContextType',
  'adminRole',
  'isSysAdmin',
  'isOrgAdmin',
  'adminFilterOrganizationId',
  'isCampaignAdmin',
  'adminFilterCampaignId',
  'isCampaignOrganizerAdmin',
  'adminFilterCampaignOrganizerId',
  'isEventAdmin',
  'adminFilterEventId',
  'isEventOrganizerAdmin',
  'adminFilterEventOrganizerId',
  'hasMfaActive'
];
export const orgAdminsAvailableFilters = [
  'status',
  'isCampaignAdmin',
  'adminFilterCampaignId',
  'hasMfaActive'
];
export const fundraisersAvailableFilters = [
  'pagesCount',
  'raisedAmount',
  'donationCount',
  'averageDonationAmount',
  'activePagesCount'
];
export const donorAvailableFilters = [
  'donationCount',
  'raisedAmount',
  'averageDonationAmount',
  'currency'
];

export const retentionAvailableFilters = [
  'accountId',
  'lastActivityType',
  'lastActivityAt',
  'firstFlaggedAt',
  'status',
  'anonymisedAt'
];

export const FUNDRAISER_ENTITY = 'account/fundraiser';
export const DONOR_ENTITY = 'account/donor';
export { RETENTION_ENTITY } from '../dataRetention/constants';

export const getTabFromAccountTypes = (account: any) => {
  if (account.isOrgAdmin || account.isSysAdmin) return tabs.ADMINS;

  if (account.isFundraiser) return tabs.FUNDRAISERS;

  return tabs.DONORS;
};

export const permissionMap = new Map([
  ['isCampaignAdmin', (account: any) => 'Campaign admin'],
  ['isCampaignOrganizerAdmin', (account: any) => 'Campaign organiser admin'],
  ['isEventAdmin', (account: any) => 'Event admin'],
  ['isEventOrganizerAdmin', (account: any) => 'Event organizer admin'],
  ['isOrgAdmin', (account: any) => account.adminMemberships.some((m: any) => m.contextType == 'organization' && m.restrictExports) ? 'Org admin (restricted)' : 'Organisation admin' ],
  ['isSysAdmin', (account: any) => 'System admin']
]);

export const getPermissionsFromAccount = (account: any) =>
  // loop permissionMap and check the permissions are true against the account object
  // for each true value, return a single string of the permission map value with ',' delim
  Array.from(permissionMap.keys())
  .reduce((result, key) => {
      const mapValue = permissionMap.get(key);
      if (account[key] && mapValue) result.push(mapValue(account));
      return result;
    }, [] as string[])
    .join(', ');

// AdminContextType values as returned by API
export const AdminContextType = {
  System: 'system',
  Organization: 'organization',
  Campaign: 'campaign',
  Event: 'event',
  CampaignOrganizer: 'campaignOrganizer',
  EventOrganizer: 'eventOrganizer'
} as const;

// Map context type string to i18n key
const adminContextTypeI18nMap: Record<string, string> = {
  [AdminContextType.System]: 'account.adminContextType.system',
  [AdminContextType.Organization]: 'account.adminContextType.organization',
  [AdminContextType.Campaign]: 'account.adminContextType.campaign',
  [AdminContextType.Event]: 'account.adminContextType.event',
  [AdminContextType.CampaignOrganizer]: 'account.adminContextType.campaignOrganizer',
  [AdminContextType.EventOrganizer]: 'account.adminContextType.eventOrganizer'
};

// Get translated context type label
export const translateContextType = (contextType: string, i18n: any): string => {
  const key = adminContextTypeI18nMap[contextType];
  return key ? i18n.t(key) : '';
};

// Map admin role string to i18n key
const adminRoleI18nMap: Record<string, string> = {
  owner: 'account.eyes-only.role.owner',
  admin: 'account.eyes-only.role.admin',
  viewer: 'account.eyes-only.role.viewer'
};

// Get translated admin role label
const translateAdminRole = (role: string, i18n: any): string => {
  const key = adminRoleI18nMap[role?.toLowerCase()];
  return key ? i18n.t(key) : role || '';
};

// Format a single admin membership for display
export const formatAdminMembership = (membership: any, i18n: any): string => {
  const contextLabel = translateContextType(membership.contextType, i18n);
  const roleLabel = translateAdminRole(membership.role, i18n);
  const entityName = membership.assignedEntityName || '';
  const restrictedSuffix = membership.restrictExports ? ` - ${i18n.t(i18nKeys.RESTRICTED_LABEL)}` : '';

  // System context has no entity
  if (membership.contextType === AdminContextType.System) {
    return roleLabel ? `${contextLabel} (${roleLabel})` : contextLabel;
  }

  const base = entityName ? `${contextLabel} - ${entityName}` : contextLabel;
  return roleLabel ? `${base} (${roleLabel})${restrictedSuffix}` : `${base}${restrictedSuffix}`;
};

// Get admin access display value and memberships for an account
export const getAdminAccessInfo = (account: any, i18n: any): { displayValue: string; memberships: string[]; isMultiple: boolean } => {
  const memberships = account.adminMemberships || [];
  
  if (memberships.length === 0) {
    return { displayValue: '', memberships: [], isMultiple: false };
  }
  
  if (memberships.length === 1) {
    return {
      displayValue: formatAdminMembership(memberships[0], i18n),
      memberships: [],
      isMultiple: false
    };
  }
  
  // Multiple memberships
  return {
    displayValue: i18n.t('account.list.header.adminAccessMultiple'),
    memberships: memberships.map((m: any) => formatAdminMembership(m, i18n)),
    isMultiple: true
  };
};

export const accountsUrl = {
  [tabs.ALL_USERS]: {
    url: 'all',
    recordUrl: '',
    type: 'all',
    view: 'fundraising'
  },
  [tabs.ADMINS]: {
    url: 'admin',
    recordUrl: '',
    type: 'admin',
    view: 'fundraising'
  },
  [tabs.FUNDRAISERS]: {
    url: 'fundraiser',
    recordUrl: 'fundraiser',
    type: 'fundraiser',
    view: 'fundraising'
  },
  [tabs.DONORS]: {
    url: 'donor',
    recordUrl: 'donor',
    type: 'donor',
    view: 'donations'
  }
};

export const subscriptionOptions = {
  in: 'in',
  out: 'out'
};

/**
 * Returns true if the account has (or previously had) a system-level admin membership.
 */
export const hasActiveOrPastSystemAdminMembership = (account: any): boolean => {
  return (
    account?.adminMemberships?.some((am: any) => am.contextType === AdminContextTypeApi.System) ||
    account?.revokedMemberships?.some((rm: any) => rm.contextType === AdminContextTypeApi.System) ||
    false
  );
};
